import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  value: {
    fullName: "",
    email: "",
    city: { value: "", label: "" },
    country: { value: "", label: "" },
    status: "",
    pagination: {
      page: 0,
      pageSize: 20,
    },
  },
};

export const engineerFiltersSlice = createSlice({
  name: "engineerFilters",
  initialState,
  reducers: {
    setEngineerFilters: (state, action) => {
      const { filterName, data } = action.payload;
      if (filterName.includes(".")) {
        const [parent, child] = filterName.split(".");
        if (state.value[parent]) {
          state.value[parent][child] = data;
        }
      } else {
        state.value[filterName] = data;
      }
    },

    resetEngineerFilters: (state) => {
      state.value = {
        fullName: "",
        email: "",
        city: { value: "", label: "" },
        country: { value: "", label: "" },
        status: "",
        pagination: { page: 0, pageSize: 20 },
      };
    },
  },
});

export const { setEngineerFilters, resetEngineerFilters } =
  engineerFiltersSlice.actions;
export default engineerFiltersSlice.reducer;
